import Indicators from './Indicators';
import Information from './Information';
import mapBuilder from './mapBuilder';
import reporting from './reporting';
import scenarioAnlysis from './scenarioAnlysis';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  // items: [widget, applications, formsTables, chartsMap, pages, other]
  items: [Information, Indicators, scenarioAnlysis, reporting, mapBuilder]
};

export default menuItems;
